import mapValues from 'lodash/mapValues';
import {modify} from 'mythil/object';
import reduceModel from "./reduceModel";
import getConfig from '~/config';
import {UI_ACTIONS} from "~/actions/ui_actions";
import {reduceLoadedModelsUi} from '~/rx/modelConfigs';
import loadModelPath from "~/reducers/helpers/loadModelPath";
import reduceSettings from "~/reducers/reduceSettings";
import {CHANGE_APP_PAGE} from "~/actions/actions";
import resetItem from "~/reducers/helpers/resetItem";
import reduceSearchModel from "~/reducers/reduceSearchModel";
import { getAppPage, isAuthenticated } from '~/stateGetter';

const reduceSearchModelAction = (ui, action, state) => {
    if (action.searchModelName && action.searchModelName in ui.searchModels) {
        return modify(ui, `searchModels.${action.searchModelName}`, (model) => reduceSearchModel(model, state, action));
    }

    return ui;
};

const reduceManySearchModelActions = (ui, action, state) => {
    if(!action.searchModelNames) {
        return ui;
    }
    
    for(let searchModelName of action.searchModelNames) {
        let preparedAction = action;
        
        if(action.value) {
            preparedAction = {...action, value: action.value[searchModelName]}
        }

        ui = reduceSearchModelAction(ui, {...preparedAction, searchModelName }, state);
    }
    
    return ui;
};

export default function reduceUi(state, action) {
    if (!isAuthenticated(state)) return state.ui;
    const appPage = getAppPage(state);
    if (appPage === "error" || appPage === 'notFound') return state.ui;

    let ui = state.ui;

    ui = reduceLoadedModelsUi(ui, action, state);

    switch(action.type) {
        case CHANGE_APP_PAGE:
            ui = modify(ui, 'loadedModels', (loadedModels) => mapValues(loadedModels, (model) => resetItem(state, model)));
            break;
        case UI_ACTIONS.SET_ACTIVE_APP_BAR_DIALOG:
            return { ...ui, activeAppBarDialog: action.dialog };
        case UI_ACTIONS.LOAD_MODEL_PATH:
            return loadModelPath(ui, action.path, action.changeRootModel, action.resetValues, state);
        case UI_ACTIONS.SET_CURRENT_MODEL_ID:
            return { ...ui, currentModelId: action.id };
        case UI_ACTIONS.SHOW_CONFIRM_NAVIGATION_DIALOG:
            return modify(ui, 'confirmNavigationMessages', () => {
               return action.messages.length ? action.messages
                   : [getConfig().defaultConfirmNavigationMessage];
            });
        case UI_ACTIONS.HIDE_CONFIRM_NAVIGATION_DIALOG:
            return modify(ui, 'confirmNavigationMessages', []);
        case UI_ACTIONS.SET_SEARCH_TERM:
            return { ...ui, searchTerm: action.searchTerm };
        case UI_ACTIONS.CLEAR_SEARCH_ERRORS:
            return {
                ...ui,
                searchModels: mapValues(
                    ui.searchModels,
                    (searchModel) => ({ ...searchModel, results: { ...searchModel.results, status: null, error: null } })
                )
            }
    }

    if(action.modelId && action.modelId in ui.loadedModels) {
        ui = modify(ui, `loadedModels.${action.modelId}`, (model) => reduceModel(model, state, action));
    }


    ui = reduceSearchModelAction(ui, action, state);
    ui = reduceManySearchModelActions(ui, action, state);
    
    ui = {
        ...ui,
        settings: reduceSettings(ui.settings, action)
    };

    return ui;
}